import type React from 'react';

import { Divider, FormField, Label, Textarea } from '@zillow/constellation-10';

import type { Section, SmokingPolicySection } from '../../../models';
import { SmokingPolicy } from '..';
import { PROPERTY_TYPE, SMOKING_POLICY } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  setSection: (section: SmokingPolicySection) => void;
};

export default function SmokingPolicy_v2({ section, setSectionValues, setSection }: Props): JSX.Element {
  function onOtherUnitDescriptionChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [SMOKING_POLICY.FIELD_NAME.OTHER_UNITS_DESCRIPTION]: value });
  }

  const isThreeUnitsOrMore = section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.THREE_UNITS_OR_MORE);
  const allowedInCertainAreas = section.getFieldValue(SMOKING_POLICY.FIELD_NAME.CERTAIN_AREAS);

  return (
    <SmokingPolicy section={section} setSectionValues={setSectionValues} setSection={setSection}>
      {isThreeUnitsOrMore && allowedInCertainAreas && (
        <>
          <Divider css={{ marginTop: 'layout.tight', marginBottom: 'layout.tighter' }} />
          <FormField
            required
            css={{ marginTop: 'layout.tight' }}
            label={<Label>Which units on the property is smoking permitted in?</Label>}
            control={
              <Textarea
                value={section.getFieldValue(SMOKING_POLICY.FIELD_NAME.OTHER_UNITS_DESCRIPTION)}
                onChange={onOtherUnitDescriptionChange}
              />
            }
          />
        </>
      )}
    </SmokingPolicy>
  );
}
SmokingPolicy_v2.description = 'Asks for other unit smoking when there are greater than 3 units';
